import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-project-other-cards',
  templateUrl: './project-other-cards.component.html',
  styleUrls: ['./project-other-cards.component.scss'],
  standalone: false,
})
export class ProjectOtherCardsComponent {
  projects = input<Array<{ uuid: string; name: string; description: string; backgroundImage?: string; status: string }>>([]);

  projectClicked = output<string>();

  readonly placeholder = 'https://fdi-files.s3.amazonaws.com/public/image-placeholder.png';

  onProjectClick(uuid: string): void {
    this.projectClicked.emit(uuid);
  }
}
